module.exports = __webpack_public_path__ + "assets/img/detail-content-img-2-2596e1d8.jpg";